import React from 'react';
import { SmallTextComponent } from 'shared-portal-component';

interface ActivityTextComponentProps {
  children: React.ReactNode;
}

const ActivityTextComponent: React.FC<ActivityTextComponentProps> = ({ children }) => (
  <SmallTextComponent>
    {children}
  </SmallTextComponent>
);

export default ActivityTextComponent;
